import { Alert, Heading, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import type { AvtaleDto } from "@/api/generated";
import { formatDateString } from "@/utils/dateTimeUtils";

export const AvtaleAvbestiltAlert = ({ avtale }: { avtale: AvtaleDto }) => {
  const { t } = useTranslation();

  return (
    <Alert data-color="success">
      <div className="flex flex-col gap-2">
        <Heading level={2} data-size="xs">
          {t("pages.avtaler.avbestilling.alert-vellykket-tittel")}
        </Heading>
        <Paragraph>
          {t("pages.avtaler.avbestilling.alert-vellykket-beskrivelse")}
        </Paragraph>
        {avtale.cancelledAt != null && (
          <span className="text-sm text-balder-text-subtle">
            {formatDateString(avtale.cancelledAt)}
          </span>
        )}
      </div>
    </Alert>
  );
};
